<template>
  <SidebarLayout>
    <template v-slot:sidebar="{ sidebar }">
      <div class="chat-sidebar-scoller">
        <div class="d-flex flex-column align-center pa-4">
          <v-btn v-if="sidebar" text block @click="startNewChat" color="white" title="New chat" class="mb-4 left-align-btn">
            <v-icon left>mdi-plus</v-icon> New Chat
          </v-btn>
          <v-btn v-if="sidebar" text block @click="openSearch" color="white" title="Search" class="left-align-btn">
            <v-icon left>mdi-magnify</v-icon> Search Chats
          </v-btn>

          <v-btn v-if="!sidebar" icon @click="startNewChat" color="white" title="New chat" class="mb-4"><v-icon>mdi-plus</v-icon></v-btn>
          <v-btn v-if="!sidebar" icon @click="openSearch" color="white" title="Search" class=""><v-icon>mdi-magnify</v-icon></v-btn>
        </div>
          
        <!-- Sidebar Divider -->
        <v-divider dark class="width-100"></v-divider>

        <div v-if="sidebar" class="d-flex flex-column pa-4">
          <div class="sidebar-section-title">Chats</div>
          <div class="">
            <div
              v-for="chat in chatList"
              :key="chat.id"
              class="chat-list-item white--text pa-2"
              @click="selectChat(chat.id)"
            >
              {{ chat.title || 'Untitled Chat' }}
            </div>
          </div>
        </div>
      </div>
      
      <!-- Search Dialog -->
      <v-dialog v-model="searchDialog" max-width="900" attach=".v-application--wrap" retain-focus>
        <v-card class="search-card dark-card outfit-regular" rounded dark style="min-height: 55vh;" >
          <v-card-title>
            <v-text-field
              v-model="searchQuery"
              autofocus
              hide-details
              filled
              rounded
              placeholder="Search chats..."
              @keyup.enter="handleSearchEnter"
            />
            <v-btn icon @click="searchDialog = false" class="ml-2">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider dark></v-divider>
          <v-card-text>
            <v-list dense class="mt-2" style="background: transparent;">
              <div v-for="group in groupedFilteredChats" :key="group.label">
                <v-subheader>{{ group.label }}</v-subheader>
                <v-list-item
                  v-for="chat in group.items"
                  :key="chat.id"
                  @click="selectChatFromSearch(chat.id)"
                >
                  <v-list-item-avatar>
                    <v-icon>mdi-message-outline</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <!-- <v-list-item-title class="font-size-22 ellipsis">{{ chat.title || 'Untitled Chat' }}</v-list-item-title> -->
                    <div class="font-size-16 ellipsis">{{ chat.title || 'Untitled Chat' }}</div>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </v-list>
            <div v-if="filteredChats.length === 0" class="d-flex flex-row align-center justify-left mt-2">
              <v-icon>mdi-magnify</v-icon><div class="grey--text ml-2 font-size-18">No Results</div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>

    <template slot="main">
      <ChatComponent />
    </template>
    
  </SidebarLayout>
</template>

<script>
import { collection, query, where, onSnapshot, orderBy, getDocs, doc, updateDoc, limit as fbLimit } from 'firebase/firestore';
import { db } from '@/firebase/init';
import ChatComponent from '@/components/chat/ChatCreator.vue';
import SidebarLayout from '@/layouts/Sidebar.vue';

export default {
  
  name: 'RealmChat',
  
  components: {
    ChatComponent,
    SidebarLayout,
  },

  // props: {
  //   sidebar: { type: Boolean, default: false },
  // },

  data() {
    return {
      chatList: [],
      selectedChat: null,
      loading: true,
      unsubscribeChats: null,
      sidebarCollapsed: false,
      searchDialog: false,
      searchQuery: '',
    };
  },
  computed: {
    activeChatId() {
      // The active chat is determined by the route parameter
      return this.$route.params.chatId || null;
    },
    filteredChats() {
      const q = (this.searchQuery || '').trim().toLowerCase();
      const list = !q
        ? this.chatList
        : this.chatList.filter(c => {
            const title = (c.title || 'Untitled Chat').toLowerCase();
            const text = (c.searchText || '').toLowerCase();
            return title.includes(q) || text.includes(q);
          });
      return list.slice(0, 10);
    },
    groupedFilteredChats() {
      const groups = []
      let label = null
      let items = []
      for (const chat of this.filteredChats) {
        const newLabel = this.groupLabelForDate(chat.createdAt)
        if (newLabel !== label) {
          if (items.length) groups.push({ label, items })
          label = newLabel
          items = []
        }
        items.push(chat)
      }
      if (items.length) groups.push({ label, items })
      return groups
    }
  },
  watch: {
    activeChatId: {
      immediate: true,
      handler() { /* no-op: ChatComponent handles messages */ }
    },
    profile(newProfile) {
      // This watcher will handle cases where the profile loads after the component is mounted,
      // or if the user changes.
      if (newProfile && newProfile.id && !this.unsubscribeChats) {
        this.fetchChats();
      }
    }
  },
  methods: {
    fetchChats() {
      // Prevent duplicate listeners
      if (this.unsubscribeChats) this.cleanup();
      if (!this.profile || !this.profile.id) {
          console.warn("fetchChats called without a profile, will retry when profile is available.");
          this.loading = false; // Ensure loading is false if we can't fetch yet
          return;
      }
      
      console.log("fetchChats called with profile:", this.profile.id);

      this.loading = true;
      const chatsQuery = query(
        collection(db, 'chats'), 
        where('ownerId', '==', this.profile.id),
        orderBy('createdAt', 'desc')
      );

      this.unsubscribeChats = onSnapshot(chatsQuery, (snapshot) => {
        this.chatList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        this.loading = false;
      }, (error) => {
        console.error("Error fetching chats:", error);
        this.$snackbar.error("Could not load your chats.");
        this.loading = false;
      });
    },
    startNewChat() {
      // Navigate to the base chat URL to start a new chat
      if (this.$route.path !== '/realm/chat') {
        this.go('RealmChat');
      }
    },
    selectChat(chatId) {
      // Navigate to the selected chat's URL
      if (this.activeChatId !== chatId) {
        this.go('RealmChat', { chatId });
      }
    },
    handleChatCreated(newChatId) {
      // When ChatSparky creates a new chat, this event is fired.
      // We then navigate to the new chat's URL.
      this.selectedChat = newChatId;
      this.go('RealmChat', { chatId: newChatId });
    },
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);

      // Function to get day with ordinal suffix (1st, 2nd, 3rd, 4th)
      const getDayWithSuffix = (day) => {
        if (day > 3 && day < 21) return `${day}th`;
        switch (day % 10) {
          case 1: return `${day}st`;
          case 2: return `${day}nd`;
          case 3: return `${day}rd`;
          default: return `${day}th`;
        }
      };
      
      const month = date.toLocaleString('default', { month: 'long' });
      const day = getDayWithSuffix(date.getDate());
      const year = date.getFullYear();

      return `${month} ${day}, ${year}`;
    },
    groupLabelForDate(timestamp) {
      if (!timestamp) return ''
      const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp)
      const now = new Date()
      const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const startOfYesterday = new Date(startOfToday)
      startOfYesterday.setDate(startOfYesterday.getDate() - 1)
      const startOfDate = new Date(date.getFullYear(), date.getMonth(), date.getDate())
      if (startOfDate.getTime() === startOfToday.getTime()) return 'Today'
      if (startOfDate.getTime() === startOfYesterday.getTime()) return 'Yesterday'
      const month = date.toLocaleString('default', { month: 'long' })
      const day = date.getDate()
      const suffix = (d) => {
        if (d > 3 && d < 21) return 'th'
        switch (d % 10) { case 1: return 'st'; case 2: return 'nd'; case 3: return 'rd'; default: return 'th' }
      }
      const base = `${month} ${day}${suffix(day)}`
      if (date.getFullYear() !== now.getFullYear()) return `${base}, ${date.getFullYear()}`
      return base
    },
    cleanup() {
      if (this.unsubscribeChats) {
        this.unsubscribeChats();
        this.unsubscribeChats = null; // Ensure we can re-subscribe
      }
      this.chatList = [];
      this.loading = true; // Set loading to true here to indicate a reset
    },
    openSearch() {
      this.searchDialog = true;
      this.$nextTick(() => {
        // keep the old value so caret is placed, no-op
      });
      // Kick off background indexing so content search works for older chats
      this.indexChatsForSearch();
    },
    selectChatFromSearch(chatId) {
      this.searchDialog = false;
      this.selectChat(chatId);
    },
    handleSearchEnter() {
      if (this.filteredChats.length > 0) {
        this.selectChatFromSearch(this.filteredChats[0].id);
      } else {
        this.searchDialog = false;
        this.startNewChat();
      }
    },
    async indexChatsForSearch() {
      try {
        const candidates = this.chatList.filter(c => !c.searchText).slice(0, 20);
        if (candidates.length === 0) return;
        await Promise.all(candidates.map(async (c) => {
          try {
            const messagesCol = collection(db, 'chats', c.id, 'messages');
            const q = query(messagesCol, orderBy('createdAt', 'asc'), fbLimit(200));
            const snap = await getDocs(q);
            const joined = snap.docs.map(d => (d.data().content || '')).join(' \n ');
            if (joined && joined.trim().length > 0) {
              await updateDoc(doc(db, 'chats', c.id), { searchText: joined.slice(-10000) });
            }
          } catch (e) {
            console.warn('index chat failed', c.id, e);
          }
        }));
      } catch (e) {
        console.warn('indexChatsForSearch error', e);
      }
    }
  },
  mounted() {
    // By the time the component is mounted, all plugins like snackbarStore are available.
    // We check if the profile is already loaded and fetch chats if it is.
    if (this.profile && this.profile.id) {
      this.fetchChats();
    }
  },
  created() {
    // We'll let the mounted hook and the watcher handle fetching.
  },
  beforeDestroy() {
    this.cleanup();
  },
};
</script>

<style scoped>
.chat-window { min-height: 0; height: 100%; position: relative; }
.chat-header { border-bottom: 1px solid #2c2c2c; background: #151515; color: #eaeaea; }
.title { font-weight: 600; }
.spacer { flex: 1 1 auto; }
.selector :deep(.v-input__slot) {
  background: #222 !important;
  color: #eaeaea; 
}
.messages { overflow-y: auto; min-height: 0; }
.message-row { display: flex; margin: 8px 0; }
.message-row.user { justify-content: flex-end; }
.message-row.assistant { justify-content: flex-start; }
.bubble { padding: 12px 14px; border-radius: 14px; background: #202124; color: #eaeaea; word-wrap: break-word; white-space: pre-wrap; }
.message-row.user .bubble { background: #1a73e8; color: white; max-width: 68%; }
.message-row.assistant .bubble { background: #2b2b2b; }
.meta { opacity: 0.6; font-size: 11px; margin-top: 6px; }
.composer { border-top: 1px solid #2c2c2c; background: #151515; }
.composer :deep(textarea) { color: #eaeaea; }
.thinking { display: flex; align-items: center; padding: 4px 0; }
.dots span { display: inline-block; width: 6px; height: 6px; margin-right: 4px; border-radius: 50%; background: #9aa0a6; animation: blink 1.2s infinite ease-in-out; }
.dots span:nth-child(2) { animation-delay: 0.2s; }
.dots span:nth-child(3) { animation-delay: 0.4s; }
@keyframes blink { 0%, 80%, 100% { opacity: 0.2 } 40% { opacity: 1 } }
.sidebar-section-title {
  color: #9aa0a6;
  font-weight: 600;
  letter-spacing: 0.4px;
}
.chat-list {
  background: transparent;
}
.chat-list-item {
  width: 100%;
  display: block;
  border-radius: 8px;
  margin: 6px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chat-list-item:hover {
  background: #303030;
  cursor: pointer;
}
.chat-subtitle {
  color: #9aa0a6 !important;
}
.left-align-btn {
  justify-content: flex-start !important;
}
.left-align-btn :deep(.v-btn__content) {
  justify-content: flex-start !important;
}
.search-card {
  background: #2b2b2b !important;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.chat-input {
  background: #303030 !important;
  color: white !important;
}
/* Keep the same background on hover/focus; override Vuetify filled field highlight */
.chat-input :deep(.v-input__slot),
.chat-input :deep(.v-input__slot:hover),
.chat-input :deep(.v-input--is-focused .v-input__slot),
.chat-input :deep(.v-input__slot:focus),
.chat-input :deep(.v-input__slot:focus-within) {
  background: #303030 !important;
  box-shadow: none !important;
}
.chat-input :deep(.v-input__append-outer) {
  margin-top: 8px;
  margin-right: 5px;
}
::v-deep .v-textarea.v-text-field--enclosed textarea {
  margin-top: 14px !important;
}
/* Normalize icon sizes and alignment for the chat textarea */
.chat-input :deep(.v-input__icon--prepend-inner .v-icon),
.chat-input :deep(.v-input__icon--append-outer .v-icon) {
  font-size: 24px !important;
}
.chat-input :deep(.v-input__icon--prepend-inner),
.chat-input :deep(.v-input__icon--append-outer) {
  align-self: center;
}
.message-input {
  width: 100%;
  max-width: 50rem;
}
.chat-sidebar-scoller {
  /* border: 2px solid yellow; */
  height: calc(100vh - 136px);
  overflow-y: scroll;
}
</style>